export default __webpack_public_path__ + "static/media/background-desktop.05acdd2f.jpg";